import * as React from 'react';
const BalaniteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M145.68 139.03c1.77-18.52-3.33-37.54-8.53-63.24-.79-3.98-1.15-9.58-1.3-14.82M54.32 139c-1.76-18.5 3.34-37.52 8.54-63.2.79-3.98 1.15-9.58 1.3-14.82M107.4 130.25c.6 2.79 1.36 5.78 2.3 8.75M92.6 130.25c-.6 2.8-1.36 5.8-2.32 8.78"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={108.66} r={8.66} className="prefix__cls-1" />
    <circle cx={100} cy={108.66} r={1.24} className="prefix__cls-1" />
    <circle cx={100} cy={108.66} r={16.14} className="prefix__cls-1" />
    <path
      d="M61.37 82.99s29.61 9.04 77.26 0M54.71 125.24s13.82 8.81 36.86 9.39M145.52 125.24s-13.82 8.81-36.86 9.39"
      className="prefix__cls-2"
    />
  </svg>
);
export default BalaniteIcon;
